import { FC, memo } from "react";
import { Box, HStack, Radio, Text } from "@chakra-ui/react";

import { ISbpTransferBank } from "../../../../../api/sbpTransfer/types.ts";
import { SbpTransferBanksPageBankImage } from "./SbpTransferBanksPageBankImage.tsx";

interface Props {
  bank: ISbpTransferBank;
  isChecked: boolean;
}

export const SbpTransferBanksPageBankItem: FC<Props> = memo(({ bank, isChecked }) => {
  return (
    <Box
      as="label"
      htmlFor={bank.schema}
      cursor="pointer"
      h="60px"
      px="20px"
      py="12px"
      bg="gray.75"
      borderRadius="12px"
    >
      <HStack spacing={0}>
        <SbpTransferBanksPageBankImage logoURL={bank.logoURL} bankName={bank.bankName} />

        <Text
          mt="2px"
          flex="1"
          variant="brand"
          lineHeight="1"
          sx={{
            "fontSize": "12px",
            "@media screen and (min-width: 376px)": {
              fontSize: "16px",
            },
          }}
        >
          {bank.bankName}
        </Text>

        <Radio
          id={bank.schema}
          value={bank.schema}
          isChecked={isChecked}
          variant="brand"
          ml="10px"
        />
      </HStack>
    </Box>
  );
});
